import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { JurisdictionsProvider } from './context/JurisdictionsProvider'
import { JurisdictionsMain } from './components/JurisdictionsMain'

export const Jurisdictions = () => {
  return (
    <NuqsAdapter>
      <JurisdictionsProvider>
        <JurisdictionsMain />
      </JurisdictionsProvider>
    </NuqsAdapter>
  )
}
